import styled from 'styled-components';

import { WHITE, BLACK } from '../../../../styles/variables.style';

import media from '../../../../styles/media.style';

export const Circle = styled.div`
  border: 1px solid ${WHITE};
  border-radius: 50%;
  height: 180px;
  min-width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-left: 12px;
  cursor: pointer;
  background-color: transparent;

  :last-child {
    margin-right: 12px;
  }
  opacity: ${({ active }) => (active ? 1 : 0.3)};
`;

export const CloseIcon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  right: 0;
  display: inline-block;
  width: 30px;
  height: 30px;
  color: ${BLACK};
  background-color: transparent;
  border: 1px solid ${WHITE};
  border-radius: 50%;
  vertical-align: middle;
  line-height: 40px;
  padding-left: 12px;

  ::after {
    content: '';
    width: 15px;
    height: 2px;
    background-color: ${WHITE};
    position: absolute;
    top: 51%;
    left: 51%;
    transform: translate(-50%, -50%);
  }

  ::before {
    content: '';
    width: 15px;
    height: 2px;
    background-color: ${WHITE};
    position: absolute;
    top: 51%;
    left: 51%;
    transition: transform 0.3s;
    transform: translate(-50%, -50%) rotate(${({ open }) => (open ? 0 : '90deg')});
  }
`;

export const ImageContainer = styled.div`
  border-radius: 50%;
  background-image: url(${({ image }) => image});
  height: 90%;
  width: 90%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export const RemoveBtn = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background-color: transparent;
  margin-left: auto;
  cursor: pointer;
`;

export const PhotoIcon = styled.img`
  margin: 0 0 5px 10px;
`;

export const PhotosWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: -16px;
  width: calc(100% + 32px);
  overflow-x: scroll;
  padding: 15px 0;

  ${media.tabletP`
    margin-left: 0;
    width: auto;
    overflow-x: auto;
  `};
`;

export const DateSubtitle = styled.p`
  color: #9b9b9b;
  font-size: 12px;
  margin: 0;
`;

export const SectionTitle = styled.h2`
  text-transform: uppercase;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 1px;
  flex: 1;
  margin: 0;
`;

export const Plus = styled.div``;

export const Title = styled.h3`
  text-transform: uppercase;
`;

export const Header = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const HeaderTitle = styled.div``;

export const Wrapper = styled.div``;

export const CancelBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: relative;
  margin-left: auto;
`;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/NewVisitPage/PhotoWidget/PhotoWidget.style.js